/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Luka Ilić",
  logo_name: "Luka Ilic",
  nickname: "Junior Sofware Engineer",
  subTitle:
    "An aspiring developer who loves to take on new projects that challenge his analytical and technological skills. Full stack, but predominantly worked on backend.",
  resumeLink:
    "https://mega.nz/file/mkNlQarJ#rd1EmSMRztocXUEIKEVsEpZohP98woPzIEoTS_DjpM8",
  portfolio_repository: "https://github.com/acikul",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/acikul",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/acikul/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link:
      "https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=lukailic100@gmail.com&subject=CONTACT&body=Hello",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  /*
  {
    name: "Stackoverflow",
    link: "https://stackoverflow.com/users/14167873/jongi95",
    fontAwesomeIcon: "fa-stack-overflow", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#FE7A16", // Reference https://simpleicons.org/?q=twitter
  },
  */
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Creating application backend in Spring Boot",
        "⚡ Implementing secure access to database",
        "⚡ Building resposive website front end using Vue and React"
      ],
      softwareSkills: [
      {
        skillName: "Java",
        fontAwesomeClassname: "simple-icons:java",
        style: {
          color: "#5C2D91",
        },
      },
      {
        skillName: "Spring Boot",
        fontAwesomeClassname: "simple-icons:springboot",
        style: {
          color: "#339933",
        },
      },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Vue",
          fontAwesomeClassname: "simple-icons:vue",
          style: {
            color: "#DD0031",
          },
        },
      ],
    },
  ],
};

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "90%",
    },
    {
      Stack: "Programming",
      progressPercentage: "95%",
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%", //Insert relative proficiency in percentage
    },
  ],
};

//Language Skill
const sLanguage = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Java", //Insert stack or technology you have experience in
      progressPercentage: "95%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Spring Boot",
      progressPercentage: "90%",
    },
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "60%", //Insert relative proficiency in percentage
    },
    {
      Stack: "C++",
      progressPercentage: "65%",
    },
    {
      Stack: "JavaScript/TypeScript",
      progressPercentage: "55%",
    },
    {
      Stack: "React",
      progressPercentage: "60%",
    },
    {
      Stack: "SQL/PLSQL",
      progressPercentage: "85%",
    },
    {
      Stack: "HTML", //Insert stack or technology you have experience in
      progressPercentage: "70%", //Insert relative proficiency in percentage
    },
    {
      Stack: "CSS",
      progressPercentage: "55%",
    },
    {
      Stack: "Bootstrap",
      progressPercentage: "63%",
    },
  ],
};

//Tools Skill
const tools = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Intellij IDEA", //Insert stack or technology you have experience in
      progressPercentage: "90%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Visual Studio Code", //Insert stack or technology you have experience in
      progressPercentage: "80%", //Insert relative proficiency in percentage
    },
    {
      Stack: "PostgreSQL", //Insert stack or technology you have experience in
      progressPercentage: "90%", //Insert relative proficiency in percentage
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
//     {
//       siteName: "HackerRank",
//       iconifyClassname: "simple-icons:hackerrank",
//       style: {
//         color: "#2EC866",
//       },
//       profileLink: "",
//     },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Faculty of Electrical Engineering and Computing",
      subtitle: "MSc in Computing",
      logo_path: "fer.png",
      alt_name: "FER",
      duration: "October 2021 - July 2023",
      descriptions: [
        "⚡ Software Engineering and Information Systems",
        "⚡ relevant courses: Advanced Algorithms and Data Structures, Advanced Databases, Advanced Web Development, Parallel Programming, Internet of Things"
      ],
      website_link: "https://www.fer.unizg.hr",
    },
    {
      title: "Faculty of Electrical Engineering and Computing",
      subtitle: "BSc in Computing",
      logo_path: "fer.png",
      alt_name: "FER",
      duration: "October 2018 - July 2021",
      descriptions: [
        "⚡ relevant courses: Object Oriented Programming, Software Engineering, Algorithms and Data Structures, Development of Software Applications, Databases, Web Software Development, Computer Security, Introduction to Artificial intelligence, Statistical Data Analysis"
      ],
      website_link: "https://www.fer.unizg.hr",
    },
  ],
};

const certifications = {
  certifications: []
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Workshops",
  description:
    "Other than academic, experience gained through internships, workshops and private standalone projects.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        // todo infobip employment
      ],
    },
    {
      title: "Internships",
      experiences: [
        //todo infobip internship
      ],
    },
    {
      title: "Workshops",
      experiences: [
        //todo eestec
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create backend projects and deploy them using cloud infrastructure. Stil trying to gain experience by trying my hands on different projects. Most of these are academic projects with some personal projects in between.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "lilic.png",
    description: "I am available on almost every social media.",
    invite: "Feel free to message me :)",
  },
   blogSection: {
    title: "Blogs",
    subtitle: "",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "",
    avatar_image_path: "",
    location_map_link: "",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "",
  }, 
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  sLanguage,
  tools,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
